import React from "react";
import styles from "./index.module.scss";
import { formatAbbreviatedCurrency } from "../../../utils/utils";
import moment from "moment";

export default function PriceDropTag({
  priceDrop,
  priceDropDate,
  type
}: {
  priceDrop: number;
  priceDropDate: Date;
  type: string;
}) {
  return (
    <>
      {priceDrop && (
        <div className={styles.priceDrop}>
          Price Drop: {formatAbbreviatedCurrency(priceDrop, "USD")} (
          {moment(priceDropDate).format("M/DD")})
        </div>
      )}
    </>
  );
}
